import { render, staticRenderFns } from "./ExchangeRecord.vue?vue&type=template&id=11ec1274&scoped=true"
import script from "./ExchangeRecord.vue?vue&type=script&lang=js"
export * from "./ExchangeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ec1274",
  null
  
)

export default component.exports